import React from 'react';
import './Menu.scss';
import { Link } from 'react-router-dom';
import menuJson from './menu.json';
import '../../resources/StandardStyles.scss';
import SubMenu from '../SubMenu/SubMenu';
import MenuHoverManager from './MenuHoverManager';

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: menuJson,
      openMenuById: 0
    };
    this.hoverManager = new MenuHoverManager({
      onOpen: this.openSubmenu,
      onClose: this.closeSubmenu
    });
  }

  componentWillUnmount() {
    this.hoverManager.closeNow();
  }

  openSubmenu = id => {
    this.setState({ openMenuById: id });
  };

  closeSubmenu = () => {
    this.setState({ openMenuById: 0 });
  };

  render() {
    return (
      <div className="menu">
        <ul className="menu__links">
          {this.state.menu.map(menuItem => (
            <li key={menuItem.id} className="menu__link-item">
              {menuItem.submenu ? (
                <div
                  onMouseEnter={() => this.hoverManager.enter(menuItem.id)}
                  onMouseLeave={() => this.hoverManager.leave()}
                  className="standard__link menu__item-trigger"
                >
                  <span className="menu__item">{menuItem.name}</span>
                  <SubMenu
                    menu={menuItem}
                    buttonHovered={this.state.openMenuById}
                    closeMenu={() => this.hoverManager.closeNow()}
                  />
                </div>
              ) : (
                <Link
                  to={menuItem.url}
                  onClick={() => this.hoverManager.closeNow()}
                  className="standard__link menu__item"
                >
                  {menuItem.name}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default Menu;
